import React from 'react';
import Icon from '../../icon';

class DatePanelHeader extends React.PureComponent {
  render() {
    const {
      prefix,
      modes,
      visibleMonth,
      momentLocale,
      locale,
      changeMode,
      goNextMonth,
      goNextYear,
      goPrevMonth,
      goPrevYear,
    } = this.props;

    const localedMonths = momentLocale.months();
    const monthLabel = localedMonths[visibleMonth.month()];
    const yearLabel = visibleMonth.format(locale.format.yearLabel);
    const btnCls = `${prefix}calendar-btn`;

    return (
      <div className={`${prefix}calendar-panel-header`}>
        <button
          role="button"
          title={locale.prevYear}
          className={`${btnCls} ${btnCls}-prev-year`}
          onClick={goPrevYear}
        >
          <Icon type="chevrons-left" />
        </button>
        <button
          role="button"
          title={locale.prevMonth}
          className={`${btnCls} ${btnCls}-prev-month`}
          onClick={goPrevMonth}
        >
          <Icon type="chevron-left-s" />
        </button>
        <div
          className={`${prefix}calendar-panel-header-full`}
          onClick={() => {
            modes.includes('month') && changeMode('month');
          }}
        >
          {yearLabel} {monthLabel}
        </div>
        <button
          role="button"
          title={locale.nextMonth}
          className={`${btnCls} ${btnCls}-next-month`}
          onClick={goNextMonth}
        >
          <Icon type="chevron-right-s" />
        </button>
        <button
          role="button"
          title={locale.nextYear}
          className={`${btnCls} ${btnCls}-next-year`}
          onClick={goNextYear}
        >
          <Icon type="chevrons-right" />
        </button>
      </div>
    );
  }
}

export default DatePanelHeader;
